import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url: '/order/momentumdrugOrder',
    method: 'post',
    data: {
      params
    }
  })
}
/**
 * 代发货药品订单
 * @param {Object} params
 */
export function momentumdrugOrder(params) {
  return request({
    url: '/order/momentumdrugOrder',
    method: 'post',
    data: params
  })
}
/**
 * 待自取药品订单
 * @param {Object} params
 */
export function selfRetrievaldrugOrder(params) {
  return request({
    url: '/order/selfRetrievaldrugOrder',
    method: 'post',
    data: params
  })
}
/**
 * 已发货药品订单
 * @param {Object} params
 */
export function alreadydrugOrder(params) {
  return request({
    url: '/order/alreadydrugOrder',
    method: 'post',
    data: params
  })
}
/**
 * 已完成药品订单
 * @param {Object} params
 */
export function completedrugOrder(params) {
  return request({
    url: '/order/completedrugOrder',
    method: 'post',
    data: params
  })
}
/**
 * 已退款药品订单
 * @param {Object} params
 */
export function retireddrugOrder(params) {
  return request({
    url: '/order/retireddrugOrder',
    method: 'post',
    data: params
  })
}
export function closeOrder(params) {
  return request({
    url: '/order/update/close',
    method: 'post',
    params: params
  })
}

export function deleteOrder(params) {
  return request({
    url: '/order/delete',
    method: 'post',
    data: params
  })
}

export function deliveryOrder(data) {
  return request({
    url: '/order/update/delivery',
    method: 'post',
    data: data
  });
}
export function getOrderDetail(id) {
  return request({
    url: '/order/drugOrderDetails',
    method: 'post',
    data: {
      patientPrescriptionDrugsOrderId: id
    }
  });
}

export function saveOrder(data) {
  return request({
    url: '/management/deliver',
    method: 'post',
    data: data
  });
}
export function cancelDeliver(data) {
  return request({
    url: '/management/cancelDeliver',
    method: 'post',
    data: data
  });
}
export function advanceOrder(data) {
  return request({
    url: '/management/advance',
    method: 'post',
    data: data
  });
}


export function expressDictList() {
  return request({
    url: '/management/expressDictList',
    method: 'post'
  });
}

export function expressInfo(data) {
  return request({
    url: '/order/expressInfo',
    method: 'post',
    data: data
  });
}

export function changeOrderStatus(data) {
  return request({
    url: '/order/changeOrderStatus',
    method: 'post',
    data: data
  });
}
export function getExpressType(data) {
  return request({
    url: '/management/expressTypeList',
    method: 'post',
    data: {
      dictId: data
    }
  });
}

export function updateReceiverInfo(data) {
  return request({
    url: '/order/update/receiverInfo',
    method: 'post',
    data: data
  });
}

export function updateMoneyInfo(data) {
  return request({
    url: '/order/update/moneyInfo',
    method: 'post',
    data: data
  });
}

export function updateOrderNote(params) {
  return request({
    url: '/order/update/note',
    method: 'post',
    params: params
  })
}
export function getLog(param) {
  return request({
    url: '/management/getLog',
    method: 'post',
    data: {
      drugsOrderId: param
    }
  })
}
export function changeStatue(data) {
  return request({
    url: '/management/changeStatue',
    method: 'post',
    data: data
  });
}
export function batchChangeStatue(data) {
  return request({
    url: '/management/batchChangeStatue',
    method: 'post',
    data: {
      list: data
    }
  });
}
export function write(data) {
  return request({
    url: '/order/write',
    method: 'post',
    data: {
      uuid: data
    }
  });
}
export function getAdress() {
  return request({
    url: '/management/getSender',
    method: 'post',
    data: {}
  });
}
export function getLevel() {
  return request({
    url: '/order/selectPharmacistLevel',
    method: 'post',
    data: {}
  });
}
// 下载
export function downloadprescription(params) {
  return request({
    url: '/order/downloadprescription',
    method: 'post',
    responseType:'blob',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })
}

export function getRemindInfo(params) {
  return request({
    url: '/index/selectPrescriptionAndDrugDTOList',
    method: 'post',
    data:params
  })
}

export function getPatientByChannelDrugOrderList(params) {
  return request({
    url: '/order/getPatientByChannelDrugOrderList',
    method: 'post',
    data:params
  })
}

export function getStockState(params) {
  return request({
    url: '/management/getStockState',
    method: 'post',
    data:params
  })
}

export function personalPharmacist(params) {
  return request({
    url: '/order/personalPharmacist',
    method: 'post',
    data:params
  })
}

export function updatePharmacist(params) {
  return request({
    url: '/order/updatePharmacist',
    method: 'post',
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js